
<template>
  <v-layout column>
    <v-flex>
      <v-layout wrap justify-space-between>
        <v-flex sm12 md8 lg10 class="jobs-row">
          <v-layout wrap mb-6 v-show="!isLoading">
            <v-flex>
              <h2
                v-if="numOfJobs > 0"
                class="display-36-24 primary--text"
                v-text="t('jobs.foundAdditionalJobs', { numOfJobs: numOfJobs })"
              />
              <!-- v-text="isNoCvPage ? t('jobs.foundAdditionalNoCvJobs', { numOfJobs: numOfJobs }) : t('jobs.foundAdditionalJobs', { numOfJobs: numOfJobs })" -->
            </v-flex>
          </v-layout>

          <Suggestions
            v-if="hasSuggestions"
            :searchSuggestions="suggestions"
            :searchTerm="searchProperties ? searchProperties.WhatFieldText : ''"
          />

          <div v-if="numOfJobs > 0">
            <div
              v-for="(item, i) in items"
              :key="i"
              class="pt-0 mb-6 jobList_vacancy"
            >
              <SectionHotJobs
                v-if="i === numOfJobsFirstChunk"
                :hot-jobs="hotJobs"
                :max-jobs="3"
                :is-load-more-banner="true"
              />

              <JobItem
                :job-details="item"
                class="job-item"
                :data-cy="`job-item${i}`"
                :is-single-job="false"
                :job-index="i"
                :recomended-job="item.JobInfo.IsRecommender"
                :isAA="true"
                :ssasource="1"
                :WhatFieldText="searchProperties.WhatFieldText"
                :is-hitech="
                  searchProperties ? searchProperties.IsHitechPage : false
                "
              />

              <v-flex class="inner_banner" v-if="i === 9">
                <client-only>
                  <BannerInJobs
                    class="pc-banner"
                    :is-hitech="
                      searchProperties ? searchProperties.IsHitechPage : false
                    "
                    :isLoading="isLoading"
                  />
                </client-only>
              </v-flex>
            </div>
          </div>

          <div class="d-flex flex-column" v-if="recommendedJobs.length > 0">
            <h4
              class="display-36-24 mt-5 mb-0 primary--text font-weight-medium"
              v-text="t('jobs.additionalJobs')"
            />
            <p
              class="display-18 pb-2 font-weight-medium"
              v-text="t('jobs.additionalJobsSun')"
            ></p>
          </div>

          <div
            v-for="(item, i) in recommendedJobs"
            :key="i"
            class="pt-0 pb-6 jobList_vacancy"
          >
            <JobItem
              :job-details="item"
              class="job-item job-item-recommended"
              :data-cy="`job-item-recommended-${i}`"
              :is-single-job="false"
              :job-index="i"
              :recomended-job="item.JobInfo.IsRecommender"
              :ssasource="5"
              :currentPage="'recommender_Search Results'"
              :WhatFieldText="searchProperties.WhatFieldText"
              :is-hitech="
                searchProperties ? searchProperties.IsHitechPage : false
              "
            />
          </div>
          <div v-if="areExtentionLists">
            <div v-if="extentionResultList.length">
              <h4
                class="display-36-24 mt-5 mb-5 primary--text font-weight-medium"
                v-text="searchProperties.SeparatorText"
              />
              <div
                v-for="(item, i) in extentionResultList"
                :key="i"
                class="pt-0 pb-6 jobList_vacancy"
              >
                <JobItem
                  :job-details="item"
                  class="job-item job-item-extention"
                  :data-cy="`job-item-extention${i}`"
                  :is-single-job="false"
                  :job-index="i"
                  :recomended-job="item.JobInfo.IsRecommender"
                  :WhatFieldText="searchProperties.WhatFieldText"
                  :is-hitech="
                    searchProperties ? searchProperties.IsHitechPage : false
                  "
                />
              </div>
            </div>
          </div>

          <div v-if="numOfJobs <= 0 && !isLoading">
            <noJobsBanner
              :WhatFieldText="
                searchProperties ? searchProperties.WhatFieldText : ''
              "
              :WhereFieldText="
                searchProperties ? searchProperties.WhereFieldText : ''
              "
              :Range="
                searchProperties ? searchProperties.Range.NameInHebrew : ''
              "
            />
          </div>

          <!-- <div class="d-flex flex-column" v-if="recommendedJobs.length > 0">
            <h4
              class="display-36-24 mt-5 mb-0 primary--text font-weight-medium"
              v-text="t('jobs.additionalJobs')"
            />
            <p
              class="display-18 pb-2 font-weight-medium"
              v-text="t('jobs.additionalJobsSun')"
            ></p>
          </div>

          <div
            v-for="(item, i) in recommendedJobs"
            :key="i"
            class="pt-0 pb-6 jobList_vacancy"
          >
            <JobItem
              :job-details="item"
              class="job-item job-item-recommended"
              :data-cy="`job-item-recommended-${i}`"
              :is-single-job="false"
              :job-index="i"
              :recomended-job="item.JobInfo.IsRecommender"
              :ssasource="5"
              :currentPage="'recommender_Search Results'"
              :WhatFieldText="searchProperties.WhatFieldText"
              :is-hitech="
                searchProperties ? searchProperties.IsHitechPage : false
              "
            />
          </div> -->
        </v-flex>

        <v-flex
          md3
          sm3
          class="ads-row d-lg-block d-md-block d-sm-none"
          v-if="!isLoading"
        >
          <v-layout colomun wrap>
            <v-flex>
              <SectionCompaniesInnerPages
                :is-hitech="
                  searchProperties ? searchProperties.IsHitechPage : false
                "
                :page="'jobsPage'"
              />
            </v-flex>
          </v-layout>
          <!-- </div> -->
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import JobItem from './Job_Item/JobItem';
import SectionCompaniesInnerPages from '@/components/Jobs_List/SectionCompaniesInnerPages';
import SectionHotJobs from '@/components/Jobs_List/SectionHotJobs';
import Suggestions from '@/components/Jobs_List/Jobs_On_Drushim/Suggestions/Suggestions';
import BannerInJobs from '@/components/Jobs_List/BannerInJobs';
import noJobsBanner from '@/components/Banners/noJobsBanner';
// const hitechCode = new Set(HITECH_CATEGORIES_LIST);

export default {
  components: {
    JobItem,
    SectionCompaniesInnerPages,
    Suggestions,
    BannerInJobs,
    noJobsBanner,
    SectionHotJobs,
  },

  data() {
    return {
      numOfJobsFirstChunk: 25,
    };
  },

  props: {
    isNoCvPage: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    numOfJobs: {
      type: Number,
      required: false,
      default: 0,
    },
    recommendedJobs: {
      type: Array,
      required: true,
      default: Array,
    },
    hotJobs: {
      type: Array,
      required: false,
      default: Array,
    },
    isLoadMoreBanner: {
      type: Boolean,
      required: false,
      default: false,
    },
    items: {
      type: Array,
      required: true,
      default: Array,
    },
    extentionResultList: {
      type: Array,
      required: false,
      default: Array,
    },
    showSeparator: {
      type: Boolean,
      required: false,
      default: false,
    },
    suggestions: {
      type: Object,
      required: false,
      default: () => {},
    },
    searchProperties: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  computed: {
    areExtentionLists() {
      return this.extentionResultList.length > 0 ? true : false;
    },

    hasSuggestions() {
      return (
        this.suggestions &&
        (this.suggestions.RecommendedSubCategories.length > 0 ||
          this.suggestions.RecommendedCategories.length > 0 ||
          this.suggestions.RecommendedZones.length > 0 ||
          this.suggestions.RecommendedRegions.length > 0)
      );
    },
  },
  methods: {
    handleSortBy(value) {
      //need to check if user logged in and has address
      this.$emit('orderBy', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.inner_banner {
  margin-top: 25px;
  text-align: center;
}
.theme--light.v-list {
  width: 100% !important;
}

.theme--light.v-list {
  background: transparent;
}

.ads-row {
  max-width: 300px;
}

.job-item {
  position: relative;
  border-right: 9px solid #f2f0ef;
}

.job-item.preferred {
  border-right: 9px solid $primary;
}

.job-item.preferred.job-submitted {
  border-right: 9px solid $lightGreen;
  background-color: $bgGrayJob;
}

.job-item.job-submitted {
  border-right: 9px solid $lightGreen;
  background-color: $bgGrayJob;
  z-index:0
}

.job-item.job-submitted.detailsIsOpen:after {
  display: none;
}

.filter-btn {
  margin: 0;
  margin-left: 14px;
  border: solid 1px #e3e4e6;
  background-color: rgba(46, 40, 36, 0);
  display: inline-flex;
  align-items: center;
  padding: 5px 10px 5px 10px;
  letter-spacing: -1px;
  font-size: 12px;
}

.filter-by-text {
  display: none;
}

.filter-icon {
  display: inline-block;
  margin-left: 6px !important;
}

.filter-icon:before {
  color: #000;
}

.filter-btn:hover {
  border: 1px solid #000;
}

h3 {
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: -0.9px;
}

.aside-ad {
  background: #3e4a54;
  text-align: center;
}

// <jobs results preloader >
.mugen-scroll {
  text-align: center;
  margin: 20px 0;
}

.mugen-scroll .resultsLoader img {
  width: 50px;
  animation: spin 1.5s infinite linear;
}

.mobile-companies {
  display: none;
}

.job-item.detailsIsOpen {
  background-color: #f6f7f9;
}

/* results loading */
@keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}

.filter-btn {
  margin: 0;
  height: 50px;
  width: 200px;
  margin-left: 14px;
  border: solid 1px #e3e4e6;
  background-color: rgba(46, 40, 36, 0);
  display: inline-flex;
  align-items: center;
  padding: 5px 10px 5px 10px;
  letter-spacing: -1px;
  font-size: 24px;
}

h6 {
  text-align: center;
}

@media screen and (min-width: 1280px) {
  .jobs-row {
    max-width: 934px;
  }

  .mobile-companies {
    display: block;
  }
}

@media screen and (min-width: 600px) {
  h6 {
    text-align: right;
  }
}
@media screen and (max-width: 600px) {
  .ads-row {
    display: none;
  }
}
</style>
